export default {
  'informative.list.header.date': 'Data de criação',
  'informative.list.header.creator': 'Criador',
  'informative.list.header.message': 'Mensagem',
  'informative.list.header.new.informative': 'Novo informativo',
  'informative.list.header.actions': 'Ações',

  'informative.form.date': 'Data',
  'informative.form.employee': 'Funcionário',
  'informative.form.mensage': 'Mensagem',
  'informative.form.userGroup': 'Grupo de Usuário',
  'informative.form.user': 'Usuários',

  'informative.create.notification.success': 'Informativo adicionado!',
  'informative.create.notification.successDescription':
    'O informativo foi adicionado com sucesso!',
  'informative.update.notification.success': 'Informativo alterado!',
  'informative.update.notification.successDescription':
    'O informativo foi alterado com sucesso!',
  'informative.notifications.remove.confirm.title':
    'Você deseja realmente excluir esse informativo?',
  'informative.notifications.remove.confirm.content':
    'Ao remover o informativo, todas as suas informações serão perdidas permanentemente. Ainda sim deseja continuar?',
  'informative.notifications.remove.success.title':
    'Informativo removido com sucesso!',
  'informative.notifications.remove.success.description':
    'O informativo foi removido com sucesso do sistema.',
};
